var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3422",
    "data-name": "Group 3422",
    transform: "translate(-303 -476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2182",
    "data-name": "Rectangle 2182",
    width: 25,
    height: 25,
    rx: 5,
    transform: "translate(303 476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "polygon-matic-logo",
    transform: "translate(306.429 480.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8185",
    className: "polygon",
    "data-name": "Path 8185",
    d: "M13.737,4.779a1.207,1.207,0,0,0-1.137,0L9.947,6.342l-1.8.995L5.542,8.9a1.207,1.207,0,0,1-1.137,0L2.368,7.668A1.155,1.155,0,0,1,1.8,6.674V4.305a1.168,1.168,0,0,1,.568-.995L4.405,2.126a1.207,1.207,0,0,1,1.137,0L7.579,3.358a1.155,1.155,0,0,1,.568.995V5.916l1.8-1.042V3.263a1.168,1.168,0,0,0-.568-.995L5.589.042a1.207,1.207,0,0,0-1.137,0L.568,2.316A1.042,1.042,0,0,0,0,3.263V7.716a1.168,1.168,0,0,0,.568.995l3.837,2.226a1.207,1.207,0,0,0,1.137,0L8.147,9.421l1.8-1.042,2.605-1.516a1.207,1.207,0,0,1,1.137,0l2.037,1.184a1.155,1.155,0,0,1,.568.995V11.41a1.168,1.168,0,0,1-.568.995l-1.989,1.184a1.207,1.207,0,0,1-1.137,0l-2.037-1.184a1.155,1.155,0,0,1-.568-.995V9.895l-1.8,1.042V12.5a1.168,1.168,0,0,0,.568.995L12.6,15.721a1.207,1.207,0,0,0,1.137,0l3.837-2.226a1.155,1.155,0,0,0,.568-.995V8a1.168,1.168,0,0,0-.568-.995Z",
    transform: "translate(0 0)",
    fill: "#083f85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.d8bd215185351de80957b39197656d50.svg";
export { ForwardRef as ReactComponent };